import React from 'react';
import { Gift, FileText, LifeBuoy, ShieldCheck, HelpCircle, Wrench, ClipboardCheck } from 'lucide-react';
function BonusMockup({
  title,
  icon: Icon,
  bgFrom,
  bgTo,
  iconColor,
  accentColor
}: {
  title: string;
  icon: React.ElementType;
  bgFrom: string;
  bgTo: string;
  iconColor: string;
  accentColor: string;
}) {
  return <div className="flex justify-center mb-6" data-id="element-13">
      <div className="relative w-48 h-56 rounded-2xl shadow-2xl overflow-hidden" style={{
      background: `linear-gradient(135deg, ${bgFrom}, ${bgTo})`,
      transform: 'perspective(800px) rotateY(-8deg) rotateX(4deg)'
    }} data-id="element-14">
        {/* Shine effect */}
        <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-transparent to-transparent pointer-events-none" data-id="element-15" />

        {/* Decorative circles */}
        <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full opacity-20" style={{
        backgroundColor: accentColor
      }} data-id="element-16" />
        <div className="absolute -bottom-4 -left-4 w-20 h-20 rounded-full opacity-15" style={{
        backgroundColor: accentColor
      }} data-id="element-17" />

        {/* Icon */}
        <div className="flex justify-center pt-8 mb-4" data-id="element-18">
          <div className="w-16 h-16 bg-white/25 backdrop-blur-sm rounded-2xl flex items-center justify-center shadow-lg" data-id="element-19">
            <Icon className="w-9 h-9" style={{
            color: 'white'
          }} data-id="element-20" />
          </div>
        </div>

        {/* Title */}
        <div className="px-4 text-center" data-id="element-21">
          <p className="text-white font-extrabold text-sm leading-tight drop-shadow-md" data-id="element-22">
            {title}
          </p>
        </div>

        {/* Bottom decorative bar */}
        <div className="absolute bottom-0 left-0 right-0 h-2" style={{
        backgroundColor: accentColor,
        opacity: 0.5
      }} data-id="element-23" />
      </div>
    </div>;
}
export function BonusSection() {
  return <section className="py-20 bg-amber-50 relative" data-id="element-24">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-25">
        <div className="text-center mb-16" data-id="element-26">
          <div className="inline-flex items-center justify-center bg-red-600 text-white font-black px-6 py-2 rounded-full mb-6 text-lg animate-pulse shadow-lg" data-id="element-27">
            🔥 GRATIS POR HOY 🔥
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#1E3A5F] mb-4 flex items-center justify-center" data-id="element-28">
            <Gift className="w-10 h-10 mr-4 text-[#F59E0B]" data-id="element-29" />
            BONOS INCLUIDOS HOY
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-30">
            Llevate estas 3 herramientas exclusivas sin costo adicional si
            completás tu pedido hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-31">
          {/* Bono 1 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-amber-200 relative transform transition duration-300 hover:-translate-y-2" data-id="element-32">
            <div className="absolute -top-5 -right-5 bg-red-500 text-white font-bold px-4 py-1 rounded-full shadow-md transform rotate-12" data-id="element-33">
              GRATIS
            </div>

            <BonusMockup title="Banco de Consignas Inteligentes" icon={HelpCircle} bgFrom="#3B82F6" bgTo="#1D4ED8" iconColor="#93C5FD" accentColor="#60A5FA" data-id="element-34" />

            <h3 className="text-xl font-bold text-[#1E3A5F] mb-2" data-id="element-35">
              🎁 Bono #1:
            </h3>
            <h4 className="text-2xl font-extrabold text-[#F59E0B] mb-4 leading-tight" data-id="element-36">
              Banco de Consignas Inteligentes
            </h4>
            <p className="text-slate-700 font-medium mb-6" data-id="element-37">
              150 preguntas organizadas por nivel listas para usar con cualquier
              lectura.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-38">
              <li className="flex items-start text-sm text-slate-600" data-id="element-39">
                <span className="text-[#16A34A] mr-2" data-id="element-40">✔</span> Consignas para
                1º y 2º / 3º y 4º / 5º y 6º
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-41">
                <span className="text-[#16A34A] mr-2" data-id="element-42">✔</span> 30 preguntas
                comodín para cualquier texto
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-43">
                <span className="text-[#16A34A] mr-2" data-id="element-44">✔</span> 24 disparadores
                de escritura de 5 minutos
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-45">
                <span className="text-[#16A34A] mr-2" data-id="element-46">✔</span> Mini guía para
                elegir la consigna según tu objetivo
              </li>
            </ul>
            <div className="bg-amber-50 p-4 rounded-xl border border-amber-100" data-id="element-47">
              <p className="text-sm font-bold text-[#1E3A5F] italic" data-id="element-48">
                Para que nunca más te quedes en blanco después de una lectura.
              </p>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-amber-200 relative transform transition duration-300 hover:-translate-y-2" data-id="element-49">
            <div className="absolute -top-5 -right-5 bg-red-500 text-white font-bold px-4 py-1 rounded-full shadow-md transform rotate-12" data-id="element-50">
              GRATIS
            </div>

            <BonusMockup title="Kit de Emergencia — 15 Minutos de Lengua" icon={Wrench} bgFrom="#16A34A" bgTo="#15803D" iconColor="#86EFAC" accentColor="#4ADE80" data-id="element-51" />

            <h3 className="text-xl font-bold text-[#1E3A5F] mb-2" data-id="element-52">
              🎁 Bono #2:
            </h3>
            <h4 className="text-2xl font-extrabold text-[#F59E0B] mb-4 leading-tight" data-id="element-53">
              Kit de Emergencia - 15 Minutos de Lengua
            </h4>
            <p className="text-slate-700 font-medium mb-6" data-id="element-54">
              58 herramientas para los días que nada sale como planeaste.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-55">
              <li className="flex items-start text-sm text-slate-600" data-id="element-56">
                <span className="text-[#16A34A] mr-2" data-id="element-57">✔</span> 25 actividades
                sin fotocopias (solo pizarrón y cuaderno)
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-58">
                <span className="text-[#16A34A] mr-2" data-id="element-59">✔</span> 10 juegos
                silenciosos para días de desorden
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-60">
                <span className="text-[#16A34A] mr-2" data-id="element-61">✔</span> 8 rutinas de
                lectura express para arrancar la clase
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-62">
                <span className="text-[#16A34A] mr-2" data-id="element-63">✔</span> Plan B para
                cuando no hay copias
              </li>
            </ul>
            <div className="bg-amber-50 p-4 rounded-xl border border-amber-100 mt-auto" data-id="element-64">
              <p className="text-sm font-bold text-[#1E3A5F] italic" data-id="element-65">
                Para el día que la fotocopiadora se rompe o llegaste tarde y no
                preparaste nada.
              </p>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-white rounded-3xl p-8 shadow-xl border-2 border-amber-200 relative transform transition duration-300 hover:-translate-y-2" data-id="element-66">
            <div className="absolute -top-5 -right-5 bg-red-500 text-white font-bold px-4 py-1 rounded-full shadow-md transform rotate-12" data-id="element-67">
              GRATIS
            </div>

            <BonusMockup title="El Escudo Escolar" icon={ClipboardCheck} bgFrom="#9333EA" bgTo="#7E22CE" iconColor="#D8B4FE" accentColor="#A855F7" data-id="element-68" />

            <h3 className="text-xl font-bold text-[#1E3A5F] mb-2" data-id="element-69">
              🎁 Bono #3:
            </h3>
            <h4 className="text-2xl font-extrabold text-[#F59E0B] mb-4 leading-tight" data-id="element-70">
              El Escudo Escolar
            </h4>
            <p className="text-slate-700 font-medium mb-6" data-id="element-71">
              Sistema de seguimiento para protegerte frente a padres y
              directivos.
            </p>
            <ul className="space-y-3 mb-6" data-id="element-72">
              <li className="flex items-start text-sm text-slate-600" data-id="element-73">
                <span className="text-[#16A34A] mr-2" data-id="element-74">✔</span> Ficha individual
                por alumno con 3 cortes anuales
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-75">
                <span className="text-[#16A34A] mr-2" data-id="element-76">✔</span> Planilla grupal
                para 30 alumnos
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-77">
                <span className="text-[#16A34A] mr-2" data-id="element-78">✔</span> Rúbrica de 4
                niveles de comprensión lectora
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-79">
                <span className="text-[#16A34A] mr-2" data-id="element-80">✔</span> Informe
                trimestral para padres listo para imprimir y firmar
              </li>
              <li className="flex items-start text-sm text-slate-600" data-id="element-81">
                <span className="text-[#16A34A] mr-2" data-id="element-82">✔</span> 24 frases listas
                para boletines e informes
              </li>
            </ul>
            <div className="bg-amber-50 p-4 rounded-xl border border-amber-100" data-id="element-83">
              <p className="text-sm font-bold text-[#1E3A5F] italic" data-id="element-84">
                Para que cuando un padre te pregunte "¿cómo lee mi hijo?" tengas
                la respuesta escrita, firmada y sellada.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}